import React from "react";
import IframeResizer from "iframe-resizer-react";
import styles from "./metabaseChart.css";

interface Props {
  url: string;
}

export const MetabaseChart = ({ url }: Props) => {
  return (
    <IframeResizer src={url} frameBorder={0} className={styles["full-width"]} checkOrigin={false} />
  );
};
